import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoButtonSecondary, RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {RouteHelper} from "../../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import TabContext from "@mui/lab/TabContext";
import TabBoxContainer from "../../../component/tabBoxContainer/TabBoxContainer";
import TabList from "@mui/lab/TabList";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import LoanRequestDetailBasicInfo from "./LoanRequestDetailBasicInfo";
import LoanRequestDetailInstallments from "./LoanRequestDetailInstallments";

export default function LoanRequestDetail() {

    const {state: location} = useLocation()
    const {id: loanRequestId} = useParams()

    const navigate = useNavigate()

    const [pageTitle, setPageTitle] = useState()

    useEffect(() => {
        if (location && location.title) {
            setPageTitle(`${location.title} (${loanRequestId})`)
        }
    }, [location]);

    const [selectedTab, setSelectedTab] = useState(tabInfo.BASIC_INFO.id)

    const handleChangeTabMenu = (event, newValue) => {
        setSelectedTab(newValue)
    }

    return (
        <RaikoBaseContainer>
            <RaikoFlexFirstChildGrowOne>
                <RaikoBreadcrumb className={css`flex-grow: 1;
                  gap: .5rem;`} breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.LoansRequests.name,
                        RouteHelper.LoansList.globalUrl
                    ),
                    raikoBreadCrumbItemGenerator(
                        pageTitle,
                        ""
                    )
                ]}/>

                <RaikoButtonSecondary
                    label={"بازگشت"}
                    onClick={_ => {
                        navigate(-1);
                    }}/>
            </RaikoFlexFirstChildGrowOne>


            <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                <TabContext value={selectedTab}>
                    <TabBoxContainer>
                        <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                            <Tab
                                label={tabInfo.BASIC_INFO.title}
                                value={tabInfo.BASIC_INFO.id}
                            />{/*
                            <Tab
                                label={tabInfo.LOAN_INSTALLMENTS.title}
                                value={tabInfo.LOAN_INSTALLMENTS.id}
                            />*/}
                        </TabList>
                    </TabBoxContainer>
                    <TabPanel value={tabInfo.BASIC_INFO.id}>
                        <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                            <LoanRequestDetailBasicInfo/>
                            <LoanRequestDetailInstallments/>
                        </RaikoGridOneColumn>
                    </TabPanel>

                    <TabPanel value={tabInfo.LOAN_INSTALLMENTS.id}>
                    </TabPanel>
                </TabContext>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>

    )
}

const tabInfo = {
    BASIC_INFO: {
        id: "BASIC_INFO",
        title: "اطلاعات پایه"
    }, LOAN_INSTALLMENTS: {
        id: "LOAN_INSTALLMENTS",
        title: "اقساط"
    }, LOAN_REPORT: {
        id: "LOAN_REPORT",
        title: "گزارشات"
    }, LOAN_DELETE: {
        id: "LOAN_DELETE",
        title: "حذف وام"
    },
}
